'use strict';

var $ = require('jquery'),
  Backbone = require('backbone'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  LoaderView = require('../Loader/LoaderView'),
  LoginView = require('../../js/session/views/LoginView'),
  designCenter = require('./design-center'),
  session = require('../../js/session/index'),
  deleteProjectModalTmpl = require('./templates/delete-project-modal.hbs'),

  STATE_CLASS = {
    deleting: 'DeleteProjectModal--deleting',
    loggedOut: 'DeleteProjectModal--loggedOut',
    loading: 'DeleteProjectModal--loading'
  };

Backbone.$ = $;

var DeleteProjectModalView = Backbone.View.extend({

  initialize: function(options) {
    options = options || {};
    this.projectId = options.projectId;

    this.loaderView = new LoaderView();
    this.loginView = new LoginView();
    this.listenTo(designCenter.projectsController.model, 'change', this.updateUiState, this);
    this.listenTo(session.sessionController.model, 'change', this.updateUiState, this);
    this.listenTo(this, 'deleteProjectModal:closed', this.resetView, this);
    mediator.on(config.events.designCenter.deleteProjectFailed, this.deleteProjectFailed, this);
  },

  tagName: 'section',
  className: 'DeleteProjectModal',
  projectId: '',
  isDeletingProject: false,
  hasDeleteProjectFailed: false,
  lastServerError: null,

  events: {
    'submit form': 'onFormSubmit',
    'click .DeleteProjectModal-deleteButton': 'onFormSubmit',
    'click .DeleteProjectModal-cancelButton': 'onCancel'
  },

  render: function() {
    this.$el.html(deleteProjectModalTmpl())
      .append(this.loaderView.el)
      .append(this.loginView.el);
    this.$form = this.$('.DeleteProjectModal-deleteForm');
    this.$errorMessage = this.$('.DeleteProjectModal-errorMessage');
    this.loaderView.render();
    this.loginView.render();
    this.updateUiState();
    return this;
  },

  onFormSubmit: function(e) {
    this.isDeletingProject = true;
    this.hasDeleteProjectFailed = false;
    this.lastServerError = null;
    mediator.trigger(config.events.designCenter.deleteProject, this.projectId);
    e.preventDefault();
  },

  onCancel: function(e) {
    e.preventDefault();
    // Sending event to the parent view (i.e popup modal, tooltip) to close it
    this.trigger('deleteProject:cancel');
  },

  resetView: function() {
    this.removeError();
    this.isDeletingProject = false;
    this.hasDeleteProjectFailed = false;
    this.lastServerError = null;
  },

  setError: function(errorText) {
    this.$errorMessage.text(errorText).show();
  },

  removeError: function() {
    this.$errorMessage.text('').hide();
  },

  updateUiState: function() {
    if (session.sessionController.isLoggedIn() === false) {
      this.showLoggedOutStateUi();
    } else {
      // We presume the user can delete a project and we'll handle a 401
      this.loginView.$el.hide();
      if (this.projectId) {
        if (designCenter.projectsController.isDeletingProject(this.projectId)) {
          this.showLoadingIndicatorUi();
        } else if (!this.isDeletingProject) {
          this.showCreateFormUi();
        }
      } else {
        this.showCreateFormUi();
      }
    }
  },

  setStateClass: function(stateClass) {
    this.$el
      .removeClass(STATE_CLASS.deleting)
      .removeClass(STATE_CLASS.loggedOut)
      .removeClass(STATE_CLASS.loading);
    this.$el.addClass(stateClass);
  },

  // If we know for sure the user is not logged in
  // we might want to change this logic so that we ping the authorize
  // endpoint if we don't know using `mediator.trigger(config.events.session.checkLoggedInState)`
  showLoggedOutStateUi: function() {
    this.setStateClass(STATE_CLASS.loggedOut);
    // These JS hide/show can be handled by CSS when it's built
    this.loginView.$el.show();
    this.$form.hide();
    this.loaderView.$el.hide();
  },

  showLoadingIndicatorUi: function() {
    this.setStateClass(STATE_CLASS.loading);
    this.isDeletingProject = true;
    // These JS hide/show can be handled by CSS when it's built
    this.$form.hide();
    this.loaderView.$el.show();
  },

  showCreateFormUi: function() {
    this.setStateClass(STATE_CLASS.deleting);
    if (this.hasDeleteProjectFailed && this.lastServerError) {
      this.setError(this.lastServerError.get('title'));
    } else {
      this.removeError();
    }
    this.$form.show();
    this.loaderView.$el.hide();
  },

  deleteProjectFailed: function(projectId, err) {
    if (this.isDeletingProject && projectId === this.projectId) {
      this.isDeletingProject = false;
      this.hasDeleteProjectFailed = true;
      this.lastServerError = err;
    }
    this.updateUiState();
  }

});

module.exports = DeleteProjectModalView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/DeleteProjectModalView.js